<template>
  <v-container fluid grid-list-md>
    <v-layout row wrap>
      <v-flex xs3 >
        <filters @resetTabs="resetTabs" @update="updateFilters" :reportType="reportType" :units="productUnit" :selectedBrand="selectedBrand"/>
      </v-flex>
      <v-flex xs9>
        <v-card flat>
          <v-card-title primary-title class="primary white--text">
            <h3 color="primary">RECORDS</h3>
          </v-card-title>
              <v-card-text>
                <v-tabs
                  v-model="reportTab"
                  background-color="transparent"
                  color="basil"
                  fixed-tabs
                  grow>
                  <v-tab
                    v-for="item in ['Sale Report','Purchase Report','Stock Report','Product Group Report']"
                    :key="item">{{ item }}
                  </v-tab>
                </v-tabs>
              <v-tabs-items>
              
              <v-tab-item>
                <v-card flat>
                  <v-card-text> 
                    <grid-view
                      :filters="filters"
                      :reportType="reportType"
                      :selectedClosingStockType="getDefaultStockReportType"/>
                  </v-card-text>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import Filters from './Filters'
import GridView from './GridView'
import { createNamespacedHelpers } from "vuex";
const mapGlobalGetters = createNamespacedHelpers("Global")["mapGetters"];
export default {
  components: {
    Filters,
    GridView
  },
  data () {
    return {
      filters: {},
      reportTab:0,
      reportType: "sale"
    }
  },
  methods: {
    updateFilters (filters) {
      this.filters = filters
    },
    resetTabs(){
      this.reportType = 'sale';
      this.reportTab = 0;
    }
  },
  created() {
    this.$bindAsArray("firms", this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("firmSettings", this.$root.$firebaseRefs.firmSettings.orderByChild('brand').equalTo(this.selectedBrand));
    if(this.$route.params.reportType) {
     switch(this.$route.params.reportType) {
        case 'purchase' : {
           this.reportType = "purchase"
           this.reportTab = 1;
           break;
        }
        case 'stock' : {
           this.reportType = "stock"
           this.reportTab = 2;
           setTimeout(() => {
             document.querySelector(".full-screen-view").click()
           }, 1000);
           break;
        }
        case 'productGroup' : {
           this.reportType = "productGroup"
           this.reportTab = 3;
           break;
        }
      }  
    }
  },
  computed: {
  ...mapGlobalGetters(["selectedBrand",'productUnit']),
    getDefaultStockReportType(){
      let val = 'APP'
      if(this.firms.length) {
        let defaultFirm = this.firms.filter(
          (item) =>
            item["brand"] === this.selectedBrand && !!item["defaultFirm"]
        )[0];
        if(defaultFirm) {
          let dfirmSetting = this.firmSettings.filter(item => item['firm'] == defaultFirm['.key'])[0];
          if(dfirmSetting && dfirmSetting.stockReportView) {
            val = dfirmSetting.stockReportView
          }
        }
      }
      return val;
    }
  },
  watch: {
    reportTab (index) {
      switch(index) {
        case 0 : {
          this.reportType = "sale"
          break;
        }
        case 1 : {
          this.reportType = "purchase"
          break;
        }
        case 2 : {
          this.reportType = "stock"
          break;
        }
        case 3 : {
          this.reportType = "productGroup"
          break;
        }
      }     
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Reports/index.vue